export default {"src":"/_next/static/media/co-logos.e4a588e3.svg","height":34,"width":472,"blurWidth":0,"blurHeight":0};